export default "__VITE_ASSET__CKKSLGuM__"